import { IViewStandbyPeriod } from '../../../../domain/standby-period/interface';
import { IAffectedSites } from '../../eventInterface';
import Typography from 'antd/lib/typography';
import { DEFAULT_DATE_TIME_FORMAT_WITHOUT_ZONE, formatToMinutesAndHours, getComputerFormattedTime } from '../../../../domain/date/date';

export type StandbyPeriodActionType = 'save' | 'update' | 'cancel' | 'create:batchByProgram';

interface IStandbyPeriodConfirmationModalContent {
    standbyPeriod: IViewStandbyPeriod;
    affectedSites: IAffectedSites[];
    actionType: StandbyPeriodActionType;
    programName?: string;
}

export const StandbyPeriodConfirmationModalContent = ({
    standbyPeriod,
    affectedSites,
    actionType,
    programName,
}: IStandbyPeriodConfirmationModalContent) => {
    const numberOfStandbyPeriods = affectedSites?.length || 1;
    const standbyPeriodSpelling = `Standby Period${numberOfStandbyPeriods > 1 ? 's' : ''}`;
    const duration_in_minutes = standbyPeriod.duration_hours * 60;

    return (
        <>
            {actionType === 'create:batchByProgram' ? (
                <Typography>
                    You are going to dispatch <strong>all sites</strong> connected to program: <strong>{programName}</strong>
                </Typography>
            ) : (
                <Typography>
                    You are going to {actionType} <strong>{numberOfStandbyPeriods}</strong> {standbyPeriodSpelling}
                </Typography>
            )}
            <Typography>
                {standbyPeriodSpelling} start{numberOfStandbyPeriods > 1 ? '' : 's'} at site's local time:{' '}
                <strong>{getComputerFormattedTime(standbyPeriod.datetime_start_local!, DEFAULT_DATE_TIME_FORMAT_WITHOUT_ZONE)}</strong>
            </Typography>
            <Typography>
                {standbyPeriodSpelling} duration: <strong>{formatToMinutesAndHours(duration_in_minutes)}</strong>.
            </Typography>
        </>
    );
};
